export const sqFeetToTonnageData = [
	{ label: '0 - 1000', value: '1.5' },
	{ label: '1000 - 1300', value: '2' },
	{ label: '1300 - 1600', value: '2.5' },
	{ label: '1600 - 1900', value: '3' },
	{ label: '1900 - 2200', value: '3.5' },
	{ label: '2200 - 2600', value: '4' },
	{ label: '2600+', value: '5' },
] as const;

export const annualACHoursData = [
	{ label: 'Less than 1 month', value: '300' },
	{ label: '1-3 months', value: '600' },
	{ label: '3-6 months', value: '900' },
	{ label: '6-9 months', value: '1500' },
	{ label: '9-12 months', value: '2550' },
] as const;
